import { useTranslation } from 'react-i18next'
import { processSteps } from '@/mocks/site'

export default function ProcessSection() {
  const { t } = useTranslation()

  return (
    <section className="w-full bg-background-50 py-20 md:py-28">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16">
          <div className="flex items-center justify-center gap-3 mb-5">
            <span className="h-px w-10 bg-primary-500" />
            <span className="section-label text-primary-700 text-[11px] md:text-xs font-medium">
              {t('process.label')}
            </span>
            <span className="h-px w-10 bg-primary-500" />
          </div>
          <h2 className="font-heading text-3xl md:text-5xl font-semibold text-foreground-950 leading-tight">
            {t('process.title')}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {processSteps.map((step, index) => (
            <article key={step.id} className="relative rounded-lg border border-background-200 bg-background-100/60 p-6 md:p-7">
              <div className="flex items-center justify-between mb-5">
                <span className="font-heading text-4xl md:text-5xl font-semibold text-primary-300">
                  {step.step}
                </span>
                {index < processSteps.length - 1 && (
                  <i className="ri-arrow-right-line text-background-500 text-xl hidden lg:block" />
                )}
              </div>
              <h3 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mb-2">
                {t(`process.steps.${step.id}.title`)}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{t(`process.steps.${step.id}.desc`)}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}